// Bolha de atendimento da plataforma (docs/ia/IA-PLATAFORMA.md, "Ajuda com a plataforma"):
//   - 'tawk': o chat ao vivo do Tawk.to (components/TawkToWidget.js), alternativa por configuração
//     (e o valor sem a variável, como nos testes);
//   - 'ia':   o padrão de produção desde 29/10/2026 (build arg do compose e do Dockerfile): o chatbot "Ajuda" (components/ajuda/AjudaWidget.js), que para o aluno também reúne a
//     "Dúvida sobre esta aula" (DuvidaIA).
// Escolhido no BUILD por REACT_APP_SUPORTE_CHAT (frontend/Dockerfile, docker-compose.yml). Voltar
// para o Tawk = rebuild com REACT_APP_SUPORTE_CHAT=tawk.

export const modoSuporteChat = (env = process.env) => (
  String((env && env.REACT_APP_SUPORTE_CHAT) || '').trim().toLowerCase() === 'ia' ? 'ia' : 'tawk'
);

export const MODO_SUPORTE_CHAT = modoSuporteChat();
